<template>
  <v-list v-if="menus.length">
    <v-subheader v-if="subheader && layout != DEFINES.LAYOUT_ADMIN">{{
      subheader
    }}</v-subheader>
    <template v-for="(item, i) in menus">
      <v-subheader v-if="item.heading" :key="'head' + i">{{
        $t(item.title)
      }}</v-subheader>
      <v-divider v-if="item.heading" :key="'div' + i"></v-divider>
      <!-- TODO:  send object of route for :to parameter-->
      <v-list-group :key="'div' + i" v-if="item.subMenu" :value="true">
        <template v-slot:activator>
          <v-list-tile
            :active-class="
              layout == DEFINES.LAYOUT_ADMIN
                ? 'saPrimary--text'
                : 'primary--text'
            "
            :color="
              layout == DEFINES.LAYOUT_ADMIN
                ? 'saPrimary--text'
                : 'primary--text'
            "
          >
            <v-list-tile-action>
              <v-icon>{{ $vuetify.icons[item.icon] }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          v-for="(item, i) in item.subMenu"
          :key="i"
          :to="{ name: item.route, params: item.params }"
          class="pl-5"
          :active-class="
            layout == DEFINES.LAYOUT_ADMIN
              ? 'saSecondary--text'
              : 'primary--text'
          "
          :color="
            layout == DEFINES.LAYOUT_ADMIN
              ? 'saSecondary--text'
              : 'primary--text'
          "
        >
          <v-list-tile-action>
            <v-icon>{{ $vuetify.icons[item.icon] }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title prepend-icon="account_circle">{{
            item.title
          }}</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-tile
        class="default-class highlight"
        :active-class="
          layout == DEFINES.LAYOUT_ADMIN ? 'saSecondary--text' : 'primary--text'
        "
        :color="
          layout == DEFINES.LAYOUT_ADMIN ? 'saSecondary--text' : 'primary--text'
        "
        v-else-if="item.visible"
        :key="i"
        :to="{ name: item.route, params: item.params, query: item.query }"
      >
        <v-list-tile-action>
          <v-icon :color="item.icon_color">{{
            $vuetify.icons[item.icon]
          }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
        <!-- <v-list-tile-action>
          <v-icon>{{ $vuetify.icons.rms_next }}</v-icon>
        </v-list-tile-action>-->
      </v-list-tile>
      <!-- Display AddOns under billing menu -->
      <!-- <AddOns
        v-if="is_add_on && item.title == 'Billing'"
        :key="i + 'add_on'"
      ></AddOns> -->
    </template>
    <!-- <Logout v-if="is_logout"></Logout> -->
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import Logout from "@/components/Logout";
import AddOns from '@/components/screener/AddOns';
export default {
  props: {
    menus: {
      default: () => [],
    },
    subheader: {
      default: "",
    },
    is_logout: {
      default: false,
    },
    is_add_on: {
      default: false,
    },
  },
  components: {
    Logout,
    AddOns,
  },
  computed: {
    ...mapGetters("app", {
      layout: "appLayout",
      session_mode: "auth/getSessionMode",
    }),
  },
};
</script>

<style>
.highlight:hover {
  background-color: #efefef;
}
</style>
